export default __webpack_public_path__ + "static/media/chevron-left-circle.84cadb64.svg";